module.exports = __webpack_public_path__ + "media/application/images/2018/icon-lock-red-circle-ffa6bdc710d794129f0e1c01b819735f.svg";